<button
	mat-button
	class="ficon-arrow-left back-btn"
	type="button"
	attr.aria-label="{{'common_back'| translate}}"
	(click)="back()">
</button>
<h1 translate="welcome-dialog-choose-plan"></h1>
<div class="plan-description" translate="welcome-dialog-plan-body"></div>
<div class="payment-option">
	<div class="payment-option-desc" translate="welcome-dialog-plan-self" id="self-pay-desc"></div>
	<div class="payment-button">
		<button class="primary-btn" (click)="proceedSelfPay()" translate="welcome-dialog-plan-self-pay" aria-describedby="self-pay-desc"></button>
	</div>
</div>
<div class="payment-option">
	<div class="payment-option-desc" translate="welcome-dialog-plan-student" id="student-pay-desc"></div>
	<div class="payment-button">
		<button class="secondary-btn" (click)="proceedStudentPay()" translate="welcome-dialog-plan-student-pay" data-cy="welcome-modal_student-btn" aria-describedby="student-pay-desc"></button>
	</div>
</div>
